/* Botanica Studio - Theme JS */
(function () {
  'use strict';

  /* ---------- Drawer open/close ---------- */
  function setupDrawer(drawerId, openSelector) {
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;
    const backdrop = document.getElementById(drawerId + '-backdrop');
    const openers = document.querySelectorAll(openSelector);
    const closers = drawer.querySelectorAll('[data-drawer-close]');

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openers.forEach(o => o.addEventListener('click', open));
    closers.forEach(c => c.addEventListener('click', close));
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupDrawer('NavDrawer', '[data-nav-open]');
    setupDrawer('CartDrawer', '[data-cart-open]');

    /* ---------- Testimonials dots ---------- */
    document.querySelectorAll('[data-testimonials]').forEach(section => {
      const slides = section.querySelectorAll('[data-testimonial-slide]');
      const dots = section.querySelectorAll('[data-testimonial-dot]');
      let current = 0;
      function show(i) {
        slides.forEach((s, idx) => s.style.display = idx === i ? 'block' : 'none');
        dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
        current = i;
      }
      if (slides.length > 0) show(0);
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      if (slides.length > 1) setInterval(() => show((current + 1) % slides.length), 6000);
    });

    /* ---------- Nav drawer: expand/collapse Shop ---------- */
    document.querySelectorAll('[data-nav-expand]').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = document.getElementById(btn.dataset.navExpand);
        if (target) target.classList.toggle('is-hidden');
      });
    });
  });
})();
